module.exports = __webpack_public_path__ + "img/2024-02-13d_1.f27cd69e.jpg";